var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _vm.innerGameDifficultyList ? _c('div', { staticClass: "multi-game-difficulty" }, [_vm._l(_vm.innerGameDifficultyList, function (difficultyItem, index) {
    return [difficultyItem.tag === _vm.category.tag && _vm.isEmpty(difficultyItem.data) ? _c('div', { key: index, staticClass: "empty-item" }, [_vm._v("\n      Empty data\n    ")]) : difficultyItem.tag === _vm.category.tag ? _c('difficulty-card', { key: index, attrs: { "config": difficultyItem, "resettable": _vm.innerGameDifficultyList.length > 1, "isDefault": difficultyItem.isDefault } }, _vm._l(difficultyItem.data, function (item, key) {
      return _c('multi-game-difficulty-item', { key: key, class: 'multi-game-difficulty-item-' + item.type }, [item.title || item.desc ? _c('v3-game-difficulty-title', { attrs: { "title": item.title, "desc": item.desc } }, [_c('reset-game-config', { attrs: { "prop": key }, on: { "change": function change(data) {
            return _vm.update(data, index);
          } } })], 1) : _vm._e(), _vm._v(" "), _c('v3-game-difficulty', { key: key, attrs: { "game-config": item, "play-config": _vm.playConfig, "key-path": key, "prefix": key }, on: { "change": function change(data) {
            return _vm.update(data, index);
          }, "add-validator": function addValidator(validate) {
            _vm.handleAddValidator({
              name: 'v3-game-difficulty',
              validate: validate
            });
          } } })], 1);
    }), 1) : _vm._e()];
  })], 2) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };